module.exports = __webpack_public_path__ + "static/media/comment-slash.cb9e6ab3.svg";